import { render, staticRenderFns } from "./TravelPolicyList.vue?vue&type=template&id=223ed442&scoped=true&"
import script from "./TravelPolicyList.vue?vue&type=script&lang=js&"
export * from "./TravelPolicyList.vue?vue&type=script&lang=js&"
import style0 from "./TravelPolicyList.vue?vue&type=style&index=0&id=223ed442&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_@vue+com_158fd1d6ef9e4cc6d0695d4cab9c983b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223ed442",
  null
  
)

export default component.exports